(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[505],{

/***/ 487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_misc_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1761);
/* harmony import */ var _styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3882);
/* harmony import */ var _styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__);




var styles = (_styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default());
var footerColumns = [
    {
        title: "О нас",
        text: _lib_misc_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_DESCRIPTION */ .PB
    },
    {
        title: "Контакты",
        links: [
            {
                name: "Электронная почта",
                href: "mailto:contact@schooltester.com"
            }
        ]
    },
    {
        title: "Сервисы",
        links: [
            {
                name: "Создать тест",
                href: "/tests/create"
            },
            {
                name: "Ваши тесты",
                href: "/tests/created"
            },
            {
                name: "Библиотека тестов",
                href: "/tests/library"
            }
        ]
    }
];
var Footer = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: styles.footer,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.container,
                children: footerColumns.map(function(footerColumn, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: styles.column,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: footerColumn.title
                            }),
                            footerColumn.text ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: footerColumn.text
                            }) : null,
                            footerColumn.links ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                children: footerColumn.links.map(function(link, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: link.href,
                                            children: link.className ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: link.className,
                                                children: link.name
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: link.name
                                            })
                                        })
                                    }, index);
                                })
                            }) : null
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: styles.bottom,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " ",
                            _lib_misc_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Все права защищены."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(414);
;// CONCATENATED MODULE: ./src/utils/handleError.util.ts



/**
 * Executes the callback function with handling all the errors.
 * @param callback Callback function to execute.
 * @returns Callback function execution result.
 */ var handleError = function(callback) {
    try {
        var result = callback();
        if ((0,_instanceof/* default */.Z)(result, Promise)) {
            var awaitResult = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var awaitedResult, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    result
                                ];
                            case 1:
                                awaitedResult = _state.sent();
                                return [
                                    2,
                                    {
                                        error: null,
                                        result: awaitedResult
                                    }
                                ];
                            case 2:
                                err = _state.sent();
                                return [
                                    2,
                                    {
                                        error: err,
                                        result: null
                                    }
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function awaitResult() {
                    return _ref.apply(this, arguments);
                };
            }();
            return awaitResult();
        }
        return {
            error: null,
            result: result
        };
    } catch (err) {
        return {
            error: err,
            result: null
        };
    }
};

// EXTERNAL MODULE: ./src/lib/misc/constants.ts
var constants = __webpack_require__(1761);
// EXTERNAL MODULE: ./src/styles/Navbar.module.css
var Navbar_module = __webpack_require__(4087);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
;// CONCATENATED MODULE: ./src/components/Navbar.tsx







var styles = (Navbar_module_default());
var Navbar = function() {
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var handleMenuToggle = function() {
        setShowMenu(!showMenu);
    };
    var hideMenu = function() {
        setShowMenu(false);
    };
    var ref1 = (0,react.useState)([]), links = ref1[0], setLinks = ref1[1];
    (0,react.useEffect)(function() {
        var accessToken = localStorage.getItem("accessToken");
        var rawUser = handleError(function() {
            return JSON.parse(localStorage.getItem("user"));
        });
        var user = rawUser.result || {};
        if (accessToken) {
            setLinks([
                {
                    name: user.username,
                    href: "#",
                    icon: "fas fa-user",
                    style: {
                        cursor: "default"
                    }
                },
                {
                    name: "Библиотека",
                    icon: "fas fa-book",
                    href: "/tests/library"
                },
                {
                    name: "Настройки аккаунта",
                    icon: "fas fa-shield-alt",
                    href: "/account"
                },
                {
                    name: "Ваши тесты",
                    icon: "fas fa-cog",
                    href: "/tests/created"
                },
                {
                    name: "Выход",
                    icon: "fas fa-door-open",
                    href: "/logout",
                    className: styles["logout-button"]
                }
            ]);
        } else {
            setLinks([
                {
                    name: "Библиотека",
                    icon: "fas fa-book",
                    href: "/tests/library"
                },
                {
                    name: "Вход",
                    icon: "fas fa-sign-in-alt",
                    href: "/login"
                },
                {
                    name: "Регистрация",
                    icon: "fas fa-user-plus",
                    href: "/register"
                }
            ]);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
            className: styles.nav,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: styles.logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/tester.svg",
                                alt: "logo",
                                height: 30,
                                width: 30
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: styles["app-name"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: constants/* APP_NAME */.iC
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: styles["menu-toggle"],
                    onClick: handleMenuToggle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: showMenu ? "fas fa-times" : "fas fa-bars"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(styles["nav-links"], " ").concat(showMenu ? styles.active : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        onClick: hideMenu,
                        children: links.map(function(link, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: link.href,
                                    children: link.className ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: link.className,
                                        style: link.style,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: link.icon
                                            }),
                                            link.name
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: link.style,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: link.icon
                                            }),
                                            link.name
                                        ]
                                    })
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Navbar = (Navbar);


/***/ }),

/***/ 6587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ getBorderStyle; }
});

// UNUSED EXPORTS: ClientFetch

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__(9704);
;// CONCATENATED MODULE: ./src/lib/auth.ts
/* provided dependency */ var process = __webpack_require__(3454);

/**
 * Generates the access token for specified user payload.
 * @param payload User payload to encode.
 * @param rememberMe If true, the access token will never expire.
 * @returns Generated access token.
 */ function generateToken(payload, rememberMe) {
    return jwt.sign(payload, process.env.PAYLOAD_SECRET, rememberMe ? undefined : {
        expiresIn: "4h"
    });
}
/**
 * Decodes the access token and returns the encoded user payload.
 * @param token Token to check.
 * @returns Decoded user payload.
 */ function auth_verifyToken(token) {
    return jwt.verify(token, process.env.PAYLOAD_SECRET);
}

// EXTERNAL MODULE: ./src/lib/misc/constants.ts
var constants = __webpack_require__(1761);
;// CONCATENATED MODULE: ./src/lib/json.ts

/**
 * Sends a JSON responce with specified responce parameters.
 * @param options JSON sending options.
 */ function json_sendJSON(options) {
    if (!options.statusCode) {
        options.statusCode = 200;
    }
    var isRequestErrored = options.statusCode >= 400;
    var fallbackRequestMessage = !isRequestErrored ? "ok" : "not ok";
    var statusCodeText = statusCodes[options.statusCode];
    var bodyToSend = {
        code: options.statusCode,
        status: !isRequestErrored,
        message: options.message ? "".concat(statusCodeText, ": ").concat(options.message) : "".concat(statusCodeText, ".") || 0,
        data: options.body
    };
    return options.res.status(options.statusCode).json(bodyToSend);
}
/**
 * Parses a JSON string with handling parsing errors.
 * @param jsonString JSON string to parseю
 * @returns Parsing result.
 */ function json_parseJSON(jsonString) {
    if (jsonString == "null" || jsonString == "{}" || jsonString == "") {
        return {
            status: true,
            errored: false,
            empty: true,
            jsonString: jsonString,
            data: null
        };
    }
    if (typeof jsonString == "object") {
        if (!Object.keys(jsonString).length) {
            return {
                status: true,
                errored: false,
                empty: true,
                jsonString: jsonString,
                data: null
            };
        }
        return {
            status: true,
            errored: false,
            empty: false,
            jsonString: jsonString,
            data: jsonString
        };
    }
    try {
        var data = JSON.parse(jsonString);
        for(var key in data){
            try {
                // getting literal number and boolean values
                data[key] = JSON.parse(data[key]);
            } catch (e) {
                // if parsing failed, then the value is string
                data[key] = data[key];
            }
        }
        return {
            status: true,
            errored: false,
            empty: false,
            jsonString: jsonString,
            data: data
        };
    } catch (err) {
        return {
            status: false,
            errored: true,
            empty: false,
            jsonString: jsonString,
            data: null
        };
    }
}

;// CONCATENATED MODULE: ./src/lib/misc/rateLimiter.ts


var defaultIPObject = {
    rateLimited: false,
    retryTimestamp: 0,
    requests: []
};
var rateLimiter_RateLimiter = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function RateLimiter() {
        _class_call_check(this, RateLimiter);
        this._rateLimits = {};
    }
    var _proto = RateLimiter.prototype;
    /**
     * Adds the specified route to the rate limiting system.
     * @param options Route options.
     */ _proto.addRoute = function addRoute(param) {
        var allowedRequestsAmount = param.allowedRequestsAmount, rateLimitInterval = param.rateLimitInterval, timeInterval = param.timeInterval, path = param.path;
        this._rateLimits[path] = {
            allowedRequestsAmount: allowedRequestsAmount,
            rateLimitInterval: rateLimitInterval,
            timeInterval: timeInterval,
            storedIPs: {}
        };
        return this._rateLimits[path];
    };
    /**
     * Gets the route rate limit info object.
     * @param route The route to get rate limit info for.
     * @returns Route rate limit info object.
     */ _proto.getRouteRateLimit = function getRouteRateLimit(route) {
        return this._rateLimits[route];
    };
    /**
     * Gets the specified IP address fro, the storage for specified route.
     * @param ip The IP to get.
     * @param route The route to get.
     * @returns Stored IP object.
     */ _proto.getStoredIP = function getStoredIP(ip, route) {
        var ref;
        var routeRateLimit = this.getRouteRateLimit(route);
        return (routeRateLimit === null || routeRateLimit === void 0 ? void 0 : (ref = routeRateLimit.storedIPs) === null || ref === void 0 ? void 0 : ref[ip]) || null;
    };
    /**
     * Adds the specified IP address to the storage for specified route.
     * @param ip The IP to add.
     * @param route The route to add.
     * @returns Stored IP object.
     */ _proto.addStoredIP = function addStoredIP(ip, route) {
        var storedIP = this.getStoredIP(ip, route);
        if (!storedIP) {
            this._rateLimits[route].storedIPs[ip] = defaultIPObject;
        }
        return storedIP || defaultIPObject;
    };
    /**
     * Edits the specified IP address in the storage for specified route.
     * @param ip The IP to add.
     * @param route The route to add.
     * @param ipDataOptions The properties to change.
     * @returns Edited IP object.
     */ _proto.editStoredIP = function editStoredIP(ip, route, ipDataOptions) {
        var storedIP = this.getStoredIP(ip, route) || this.addStoredIP(ip, route);
        storedIP = _object_spread({}, storedIP, ipDataOptions);
        this._rateLimits[route].storedIPs[ip] = storedIP;
        return storedIP;
    };
    /**
     * Check if specified IP address is rate limited for specified route.
     * @param ip The IP address to check.
     * @param route The route to check.
     * @returns Whether the IP address is rate limited for specified route.
     */ _proto.isRateLimited = function isRateLimited(ip, route) {
        var storedIP = this.getStoredIP(ip, route);
        return storedIP.rateLimited;
    };
    /**
     * Adds the request for specified IP address and route.
     * @param ip The IP address to add the requests for.
     * @param route The route to add the requests for.
     * @returns New requests array for specified IP address and route.
     */ _proto.addRequest = function addRequest(ip, route) {
        var storedIP = this.getStoredIP(ip, route) || this.addStoredIP(ip, route);
        storedIP.requests.push({
            timestamp: Date.now()
        });
        var newStoredIP = this.editStoredIP(ip, route, {
            requests: storedIP.requests
        });
        return newStoredIP.requests;
    };
    /**
     * Rate limit the specified IP address from making requests to the specified route.
     * @param ip The IP address to rate limit.
     * @param route The route to rate limit for.
     */ _proto.setRateLimit = function setRateLimit(ip, route) {
        var routeRateLimit = this.getRouteRateLimit(route);
        var storedIP = this.getStoredIP(ip, route);
        if (!storedIP.rateLimited) {
            var newStoredIP = this.editStoredIP(ip, route, {
                rateLimited: true,
                retryTimestamp: Date.now() + routeRateLimit.rateLimitInterval
            });
            return newStoredIP;
        }
        return storedIP;
    };
    /**
     * Clear the rate limit restrictions for the specified IP address
     * from making requests to the specified route.
     *
     * @param ip The IP address to clear the rate limit restrictions from.
     * @param route The route to clear the rate limit restrictions for.
     */ _proto.clearRateLimit = function clearRateLimit(ip, route) {
        var newStoredIP = this.editStoredIP(ip, route, {
            rateLimited: false,
            requests: [],
            retryTimestamp: 0
        });
        return newStoredIP;
    };
    /**
     * Gets the rate limits storage object.
     * @returns Rate limits storage object.
     */ _proto.getStorage = function getStorage() {
        return this._rateLimits;
    };
    return RateLimiter;
}()));

// EXTERNAL MODULE: ./src/lib/user.ts
var user = __webpack_require__(6448);
;// CONCATENATED MODULE: ./src/lib/handlers/RouteHandler.ts








// import { Cacher } from '../misc/cacher'


var yellow = constants/* consoleColors.yellow */.ct.yellow, lightGreen = constants/* consoleColors.lightGreen */.ct.lightGreen, red = constants/* consoleColors.red */.ct.red, lightCyan = constants/* consoleColors.lightCyan */.ct.lightCyan, lightRed = constants/* consoleColors.lightRed */.ct.lightRed, RouteHandler_reset = constants/* consoleColors.reset */.ct.reset, green = constants/* consoleColors.green */.ct.green, lightBlue = constants/* consoleColors.lightBlue */.ct.lightBlue;
var RouteHandler = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function RouteHandler(routeHandlerOptions) {
        _class_call_check(this, RouteHandler);
        /**
     * Rate limiter instance.
     */ this.rateLimiter = new RateLimiter();
        /**
     * Cache manager instance.
     */ /*public cache = new Cacher<
        ['users', 'tests'],
        [IUser, ITest]
    >(['users', 'tests'])
*/ /**
     * HTTP method that was used to make the request.
     */ this.requestMethod = null;
        /**
     * Parsing result of request body JSON.
     */ this.body = null;
        /**
     * Request query parameters.
     */ this.query = null;
        /**
     * Decoded token payload from the `Authorization` header.
     */ this.authorization = null;
        /**
     * Next.js API Request instance.
     */ this.req = null;
        /**
     * Next.js API Responce instance.
     */ this.res = null;
        /**
     * IP address the request was made from.
     */ this.ip = null;
        /**
     * Path to the API route that was requested.
     */ this.url = null;
        this.options = routeHandlerOptions;
    }
    var _proto = RouteHandler.prototype;
    /**
     * Request handler function.
     * @param auth Auth object if it's required.
     */ _proto.handle = function handle() {
        var _this = this;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                sendJSON({
                    res: _this.res,
                    statusCode: 501,
                    message: "This request was not implemented yet.",
                    body: {}
                });
                return [
                    2
                ];
            });
        })();
    };
    return RouteHandler;
}()));
function createHandler(handler) {
    return function() {
        var _ref = _async_to_generator(function(req, res) {
            var ref, ref1, ref2, _options, ref3, _options1, ref4, rateLimiter, rateLimitOptions, bodyValidationResult, queryValidationResult, routeRateLimit, storedIP, allowedTimeInterval, requests, retryAfter, ref5, authToken, requiredBodyProperties, requiredQueryProperties, bodyData, query, possibleMethods, methodNotAllowedMessage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, requiredQueryProperty, paramWord, paramWord1, propertyWord, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, requiredBodyProperty, propertyWord1, tokenVerifyingResult, decodedPayload, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        rateLimiter = handler.rateLimiter;
                        rateLimitOptions = handler.options.rateLimit;
                        handler.requestMethod = req.method;
                        handler.req = req;
                        handler.res = res;
                        handler.ip = (ref1 = (ref = req.headers["x-forwarded-for"] || req.socket.remoteAddress) === null || ref === void 0 ? void 0 : ref.replace("::ffff:", "")) === null || ref1 === void 0 ? void 0 : ref1.replace("::1", "127.0.0.1");
                        handler.url = (ref2 = req.url) === null || ref2 === void 0 ? void 0 : ref2.replace(API_URL, "");
                        handler.body = parseJSON(req.body || "");
                        handler.query = parseJSON(JSON.stringify(req.query || ""));
                        if (!handler.options.validateBodyProps) {
                            handler.options.validateBodyProps = function() {
                                return null;
                            };
                        }
                        if (!handler.options.validateQuery) {
                            handler.options.validateQuery = function() {
                                return null;
                            };
                        }
                        bodyValidationResult = (ref3 = (_options = handler.options).validateBodyProps) === null || ref3 === void 0 ? void 0 : ref3.call(_options, handler.body.data || {});
                        queryValidationResult = (ref4 = (_options1 = handler.options).validateQuery) === null || ref4 === void 0 ? void 0 : ref4.call(_options1, handler.query.data || {});
                        if (bodyValidationResult === null || bodyValidationResult === void 0 ? void 0 : bodyValidationResult.failed) {
                            sendRouteLog({
                                method: req.method,
                                ip: handler.ip,
                                url: req.url,
                                statusCode: 400
                            });
                            return [
                                2,
                                sendJSON({
                                    res: res,
                                    statusCode: 400,
                                    message: bodyValidationResult.message,
                                    body: {
                                        failedProperty: bodyValidationResult.failed
                                    }
                                })
                            ];
                        }
                        if (queryValidationResult === null || queryValidationResult === void 0 ? void 0 : queryValidationResult.failed) {
                            sendRouteLog({
                                method: req.method,
                                ip: handler.ip,
                                url: req.url,
                                statusCode: 400
                            });
                            return [
                                2,
                                sendJSON({
                                    res: res,
                                    statusCode: 400,
                                    message: queryValidationResult.message,
                                    body: {
                                        failedProperty: queryValidationResult.failed
                                    }
                                })
                            ];
                        }
                        routeRateLimit = rateLimiter.getRouteRateLimit(handler.url);
                        storedIP = rateLimiter.getStoredIP(handler.ip, handler.url);
                        if (!routeRateLimit) {
                            routeRateLimit = rateLimiter.addRoute(_object_spread({
                                path: handler.url
                            }, rateLimitOptions));
                        }
                        if (!storedIP) {
                            storedIP = rateLimiter.addStoredIP(handler.ip, handler.url);
                        }
                        allowedTimeInterval = Date.now() - routeRateLimit.timeInterval;
                        requests = storedIP.requests.filter(function(request) {
                            return request.timestamp > allowedTimeInterval;
                        });
                        if (storedIP.rateLimited && Date.now() >= storedIP.retryTimestamp) {
                            rateLimiter.clearRateLimit(handler.ip, handler.url);
                        }
                        if (requests.length + 2 > rateLimitOptions.allowedRequestsAmount && !storedIP.rateLimited) {
                            rateLimiter.setRateLimit(handler.ip, handler.url);
                        }
                        if (storedIP.rateLimited && Date.now() < storedIP.retryTimestamp) {
                            retryAfter = Math.floor((storedIP.retryTimestamp - Date.now()) / 1000) + 1;
                            res.setHeader("Retry-After", retryAfter);
                            sendRouteLog({
                                method: req.method,
                                ip: handler.ip,
                                url: req.url,
                                statusCode: 429
                            });
                            return [
                                2,
                                sendJSON({
                                    res: res,
                                    statusCode: 429,
                                    body: {
                                        retryAfter: retryAfter
                                    }
                                })
                            ];
                        }
                        rateLimiter.addRequest(handler.ip, handler.url);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        authToken = ((ref5 = req.headers.authorization) === null || ref5 === void 0 ? void 0 : ref5.replace("Bearer ", "")) || "";
                        requiredBodyProperties = handler.options.requiredBodyProperties;
                        requiredQueryProperties = handler.options.requiredQueryProperties;
                        bodyData = handler.body.data;
                        query = handler.query.data;
                        possibleMethods = handler.options.methods;
                        if (!possibleMethods.includes(req.method)) {
                            methodNotAllowedMessage = "This method is not allowed. ";
                            if (possibleMethods.length == 1) {
                                methodNotAllowedMessage += "Only '".concat(possibleMethods[0], "' method can be used for this request.");
                            } else {
                                methodNotAllowedMessage += "Only '".concat(possibleMethods.map(function(httpMethod) {
                                    return "'".concat(httpMethod, "'");
                                }).join(", "), "' ") + "methods can be used for this request.";
                            }
                            sendRouteLog({
                                method: req.method,
                                ip: handler.ip,
                                url: req.url,
                                statusCode: 405
                            });
                            return [
                                2,
                                sendJSON({
                                    res: res,
                                    statusCode: 405,
                                    message: methodNotAllowedMessage,
                                    body: {}
                                })
                            ];
                        }
                        if (handler.options.requiredQueryProperties.length) {
                            if (Object.keys(query || {}).length) {
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = requiredQueryProperties[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        requiredQueryProperty = _step.value;
                                        if ((query === null || query === void 0 ? void 0 : query[requiredQueryProperty]) == undefined) {
                                            paramWord = requiredQueryProperties.length == 1 ? "parameter" : "parameters";
                                            sendRouteLog({
                                                method: req.method,
                                                ip: handler.ip,
                                                url: req.url,
                                                statusCode: 400
                                            });
                                            return [
                                                2,
                                                sendJSON({
                                                    res: res,
                                                    statusCode: 400,
                                                    message: "".concat(requiredQueryProperties.map(function(bodyProp) {
                                                        return "'".concat(bodyProp, "'");
                                                    }).join(", "), " query ").concat(paramWord, " should be specified."),
                                                    body: {
                                                        specifiedParams: Object.keys(query || {})
                                                    }
                                                })
                                            ];
                                        }
                                    }
                                } catch (err1) {
                                    _didIteratorError = true;
                                    _iteratorError = err1;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            } else {
                                paramWord1 = requiredQueryProperties.length == 1 ? "parameter" : "parameters";
                                sendRouteLog({
                                    method: req.method,
                                    ip: handler.ip,
                                    url: req.url,
                                    statusCode: 400
                                });
                                return [
                                    2,
                                    sendJSON({
                                        res: res,
                                        statusCode: 400,
                                        message: "".concat(requiredQueryProperties.map(function(bodyProp) {
                                            return "'".concat(bodyProp, "'");
                                        }).join(", "), " query ").concat(paramWord1, " should be specified."),
                                        body: {
                                            specifiedParams: Object.keys(query || {})
                                        }
                                    })
                                ];
                            }
                        }
                        if (handler.body.empty && handler.options.requiredBodyProperties.length) {
                            propertyWord = requiredBodyProperties.length == 1 ? "property" : "properties";
                            sendRouteLog({
                                method: req.method,
                                ip: handler.ip,
                                url: req.url,
                                statusCode: 400
                            });
                            return [
                                2,
                                sendJSON({
                                    res: res,
                                    statusCode: 400,
                                    message: "".concat(requiredBodyProperties.map(function(bodyProp) {
                                        return "'".concat(bodyProp, "'");
                                    }).join(", "), " ").concat(propertyWord, " should be specified."),
                                    body: {
                                        specifiedProps: Object.keys(bodyData || {})
                                    }
                                })
                            ];
                        }
                        if (req.method == RouteHandler_HTTPMethod.GET && !handler.body.empty) {
                            sendRouteLog({
                                method: req.method,
                                ip: handler.ip,
                                url: req.url,
                                statusCode: 406
                            });
                            return [
                                2,
                                sendJSON({
                                    res: res,
                                    statusCode: 406,
                                    message: "GET method requests cannot have a body. Use query parameters instead.",
                                    body: {}
                                })
                            ];
                        }
                        if (!handler.body.empty) {
                            if (handler.body.errored) {
                                sendRouteLog({
                                    method: req.method,
                                    ip: handler.ip,
                                    url: req.url,
                                    statusCode: 400
                                });
                                return [
                                    2,
                                    sendJSON({
                                        res: res,
                                        statusCode: 400,
                                        message: "Invalid request JSON was provided.",
                                        body: {}
                                    })
                                ];
                            }
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = requiredBodyProperties[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    requiredBodyProperty = _step1.value;
                                    if ((bodyData === null || bodyData === void 0 ? void 0 : bodyData[requiredBodyProperty]) == undefined) {
                                        propertyWord1 = requiredBodyProperties.length == 1 ? "property" : "properties";
                                        sendRouteLog({
                                            method: req.method,
                                            ip: handler.ip,
                                            url: req.url,
                                            statusCode: 400
                                        });
                                        return [
                                            2,
                                            sendJSON({
                                                res: res,
                                                statusCode: 400,
                                                message: "".concat(requiredBodyProperties.map(function(bodyProp) {
                                                    return "'".concat(bodyProp, "'");
                                                }).join(", "), " ").concat(propertyWord1, " should be specified."),
                                                body: {
                                                    specifiedProps: Object.keys(bodyData || {})
                                                }
                                            })
                                        ];
                                    }
                                }
                            } catch (err1) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err1;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                        if (handler.options.requiresAuthorization) {
                            tokenVerifyingResult = handleError(function() {
                                return verifyToken(authToken);
                            });
                            decodedPayload = tokenVerifyingResult.result;
                            if (!decodedPayload) {
                                sendRouteLog({
                                    method: req.method,
                                    ip: handler.ip,
                                    url: req.url,
                                    statusCode: 401
                                });
                                return [
                                    2,
                                    sendJSON({
                                        res: res,
                                        statusCode: 401,
                                        message: "Access token is either invalid or not provided.",
                                        body: {}
                                    })
                                ];
                            }
                            if (!decodedPayload.verified && handler.options.requiresVerification) {
                                sendRouteLog({
                                    method: req.method,
                                    ip: handler.ip,
                                    url: req.url,
                                    statusCode: 403
                                });
                                return [
                                    2,
                                    sendJSON({
                                        res: res,
                                        statusCode: 403,
                                        message: "You must be verified to do this request.",
                                        body: {
                                            accountVerified: decodedPayload.verified
                                        }
                                    })
                                ];
                            }
                            if (decodedPayload.role < handler.options.requiredRole) {
                                sendRouteLog({
                                    method: req.method,
                                    ip: handler.ip,
                                    url: req.url,
                                    statusCode: 403
                                });
                                return [
                                    2,
                                    sendJSON({
                                        res: res,
                                        statusCode: 403,
                                        message: "You don't have permissions to do this request. " + "Only ".concat(userRoles[handler.options.requiredRole], " or above can do this request."),
                                        body: {
                                            accountRole: userRoles[decodedPayload.role],
                                            requiredRole: userRoles[handler.options.requiredRole]
                                        }
                                    })
                                ];
                            }
                            handler.authorization = decodedPayload;
                        }
                        return [
                            4,
                            handler.handle()
                        ];
                    case 2:
                        _state.sent();
                        sendRouteLog({
                            method: req.method,
                            ip: handler.ip,
                            url: req.url,
                            statusCode: res.statusCode
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        sendRouteLog({
                            method: req.method,
                            ip: handler.ip,
                            url: req.url,
                            statusCode: 500
                        });
                        console.error(err);
                        return [
                            2,
                            sendJSON({
                                res: res,
                                statusCode: 500,
                                message: "Something went wrong.",
                                body: {}
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(req, res) {
            return _ref.apply(this, arguments);
        };
    }();
}
function sendRouteLog(param) {
    var method = param.method, url = param.url, statusCode = param.statusCode, ip = param.ip;
    var statusColor = statusCode >= 500 ? lightRed : statusCode >= 400 ? red : lightGreen;
    console.log("".concat(lightBlue, "[").concat(ip, "]").concat(RouteHandler_reset, " - ").concat(yellow).concat(method, " ").concat(green).concat(url).concat(RouteHandler_reset, " - ") + "".concat(statusColor).concat(statusCode, " ").concat(statusCodes[statusCode]).concat(RouteHandler_reset, " - ") + "".concat(lightCyan).concat(new Date().toLocaleString("en")).concat(RouteHandler_reset));
}
var RouteHandler_HTTPMethod;
(function(HTTPMethod) {
    HTTPMethod["GET"] = "GET";
    HTTPMethod["HEAD"] = "HEAD";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["DELETE"] = "DELETE";
    HTTPMethod["OPTIONS"] = "OPTIONS";
    HTTPMethod["PATCH"] = "PATCH";
})(RouteHandler_HTTPMethod || (RouteHandler_HTTPMethod = {}));

;// CONCATENATED MODULE: ./src/lib/misc/utils/client.ts




// TODO: typed "fetch" for client side and migrate on it
var ClientFetch = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ClientFetch(fetchOptions) {
        _class_call_check(this, ClientFetch);
        this._ok = null;
        this.code = null;
        this.error = null;
        this.response = null;
        this.options = fetchOptions;
    }
    var _proto = ClientFetch.prototype;
    /**
     * Makes an HTTP request with specified request data.
     * @returns {Promise<boolean>} Whether the responce convertation to JSON was successful.
     */ _proto.fetch = function fetch1() {
        var _this = this;
        return _async_to_generator(function() {
            var _options, url, body, method, authentication, request, data;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _options = _this.options, url = _options.url, body = _options.body, method = _options.method, authentication = _options.authentication;
                        return [
                            4,
                            fetch(url, {
                                body: JSON.stringify(body),
                                method: method || HTTPMethod.GET,
                                headers: {
                                    authentication: authentication
                                }
                            })
                        ];
                    case 1:
                        request = _state.sent();
                        _this._ok = request.ok;
                        _this.code = request.status;
                        return [
                            4,
                            request.json()
                        ];
                    case 2:
                        data = _state.sent();
                        try {
                            if (!request.ok) {
                                _this.error = data;
                            } else {
                                _this.response = data;
                            }
                        } catch (e) {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            2,
                            true
                        ];
                }
            });
        })();
    };
    /**
     * **[TYPE-GUARD]** Determines whether the request fetching process was completed.
     * @returns Whether the request fetching process was completed.
     */ _proto.isFetched = function isFetched() {
        return this._ok !== null;
    };
    /**
     * **[TYPE-GUARD]** Determines whether the responce is not OK.
     *
     * - Requires the usage of {@link ClientFetch.isFetched()} type-guard before running this method.
     * @returns Whether the request failed.
     */ _proto.isErrored = function isErrored() {
        return this._ok == false;
    };
    /**
     * Retrieves the details of the request error.
     *
     * - Requires the usage of {@link ClientFetch.isFetched()} and
     * {@link ClientFetch.isErrored()} type-guards before running this method.
     * @returns Request error details object.
     */ _proto.getError = function getError() {
        if (!this.isFetched() || !this.isErrored()) {
            return {
                code: 0,
                responce: {}
            };
        }
        return {
            code: this.code,
            responce: this.error
        };
    };
    /**
     * Retrieves the request JSON responce.
     *
     * - Requires the usage of {@link ClientFetch.isFetched()} type-guard before running this method.
     * @returns Request JSON responce object.
     */ _proto.getResult = function getResult() {
        if (!this.isFetched() || !this.isErrored()) {
            return null;
        }
        return this.response;
    };
    return ClientFetch;
}()));
/**
 * Returns the border style string based on its size and color.
 * @param size Border size in pixels.
 * @param color Border color.
 * @returns Border style string.
 */ var getBorderStyle = function(size, color) {
    return "".concat(size, "px solid ").concat(color);
};


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ validateString; },
/* harmony export */   "o": function() { return /* binding */ validateEmail; }
/* harmony export */ });
function validateEmail(email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}
function validateString(input, param) {
    var _minLength = param.minLength, minLength = _minLength === void 0 ? 0 : _minLength, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? Infinity : _maxLength, _toIncludeCapitalLetters = param.toIncludeCapitalLetters, toIncludeCapitalLetters = _toIncludeCapitalLetters === void 0 ? false : _toIncludeCapitalLetters, _toIncludeSpecialCharacters = param.toIncludeSpecialCharacters, toIncludeSpecialCharacters = _toIncludeSpecialCharacters === void 0 ? false : _toIncludeSpecialCharacters, toMatchPattern = param.toMatchPattern;
    if (input.length < minLength || input.length > maxLength) {
        return false;
    }
    if (toIncludeCapitalLetters && !/[A-Z]/.test(input)) {
        return false;
    }
    if (toIncludeSpecialCharacters && !/[!@#$%^&*(),.?":{}|<>]/.test(input)) {
        return false;
    }
    if (toMatchPattern && !toMatchPattern.test(input)) {
        return false;
    }
    return true;
}


/***/ }),

/***/ 6448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bo": function() { return /* binding */ userRolesInRussian; },
/* harmony export */   "i4": function() { return /* binding */ UserRole; }
/* harmony export */ });
/* unused harmony export userRoles */
var UserRole;
(function(UserRole) {
    UserRole[UserRole["USER"] = 0] = "USER";
    UserRole[UserRole["MODERATOR"] = 1] = "MODERATOR";
    UserRole[UserRole["ADMIN"] = 2] = "ADMIN";
})(UserRole || (UserRole = {}));
var userRoles = (/* unused pure expression or super */ null && ([
    "User",
    "Moderator",
    "Admin"
]));
var userRolesInRussian = [
    "Пользователь",
    "Модератор",
    "Админитратор"
];


/***/ }),

/***/ 3882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__pJUho","container":"Footer_container__z46Qy","column":"Footer_column__V2CwQ","bottom":"Footer_bottom__WPI3G"};

/***/ }),

/***/ 7049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__uIRNh","main":"Form_main__a16Zp","form":"Form_form__sAxPa","title":"Form_title__OVe54","input":"Form_input__aosMq","label":"Form_label__kp_zC","button":"Form_button__nEJkr","processing":"Form_processing__E9c2z","spaced-button":"Form_spaced-button___HnEb","link":"Form_link__2o5rA","link-blue":"Form_link-blue__vbuZt","error":"Form_error__QpMMq","notice":"Form_notice__JEFlo","checkboxes":"Form_checkboxes__vb7f_","checkbox-container":"Form_checkbox-container__fhI2B","info-entry":"Form_info-entry__Y6_2i","danger-button":"Form_danger-button__K3RRj","info":"Form_info__bCF4i","block":"Form_block__NQxSk","text-input":"Form_text-input__5Lr3w"};

/***/ }),

/***/ 4087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"app-name":"Navbar_app-name__LqqBn","nav":"Navbar_nav__FD0Ny","logo":"Navbar_logo__8xjov","nav-links":"Navbar_nav-links__X4a2i","menu-toggle":"Navbar_menu-toggle__l19zu","footer":"Navbar_footer__f2EX3","logout-button":"Navbar_logout-button__e9VIT","active":"Navbar_active__dvQhm"};

/***/ })

}]);